module.exports = __webpack_public_path__ + "odinstatic/media/operations.c87f648f.svg";